import { extendTheme } from '@chakra-ui/react'

export const theme = extendTheme({
  fonts: {
    heading: "'Playfair Display', Georgia, serif",
    body: "'Inter', system-ui, sans-serif",
  },
  colors: {
    ink: {
      600: '#2a2a2a',
      700: '#1c1c1c',
      800: '#141414',
      900: '#0d0d0d',
    },
    crimson: {
      50: '#fdf2f4',
      100: '#f9dbe1',
      200: '#f0a8b5',
      300: '#e06b80',
      400: '#d43355',
      500: '#c41230',
      600: '#a30e27',
      700: '#7d0a1e',
    },
    gold: {
      100: '#fdf3d3',
      200: '#fae4a0',
      300: '#f7d05c',
      400: '#f2b705',
      500: '#e8a317',
      600: '#c1860c',
    },
    cream: {
      50: '#faf3e8',
      100: '#f4ead9',
      200: '#e9dac1',
      300: '#d9c5a4',
    },
    wa: {
      500: '#25d366',
      600: '#1eb356',
    },
  },
  styles: {
    global: {
      'html, body': {
        bg: 'ink.900',
        color: 'cream.50',
        fontSize: { base: '16px', md: '17px' },
        lineHeight: 1.7,
      },
      '#root': { width: '100%' },
      ':focus-visible': {
        outline: '2px solid',
        outlineColor: 'gold.400',
        outlineOffset: '3px',
      },
    },
  },
  components: {
    Heading: {
      baseStyle: {
        fontWeight: 700,
        lineHeight: 1.08,
      },
    },
    Button: {
      baseStyle: {
        fontFamily: "'Inter', sans-serif",
        fontWeight: 600,
        letterSpacing: '0.08em',
        borderRadius: 'full',
        transition: 'all 0.25s ease',
      },
      variants: {
        whatsapp: {
          bg: 'wa.500',
          color: 'ink.900',
          _hover: {
            bg: 'wa.500',
            textDecoration: 'none',
            transform: 'translateY(-2px)',
            boxShadow: '0 0 0 4px rgba(37,211,102,0.2), 0 14px 34px rgba(37,211,102,0.35)',
          },
          _active: { bg: 'wa.600', transform: 'translateY(0)' },
        },
        gold: {
          bg: 'gold.400',
          color: 'ink.900',
          _hover: {
            bg: 'gold.300',
            textDecoration: 'none',
            transform: 'translateY(-2px)',
            boxShadow: '0 0 0 4px rgba(242,183,5,0.2), 0 14px 34px rgba(242,183,5,0.35)',
          },
          _active: { bg: 'gold.500', transform: 'translateY(0)' },
        },
        crimson: {
          bg: 'crimson.500',
          color: 'cream.50',
          _hover: {
            bg: 'crimson.400',
            textDecoration: 'none',
            transform: 'translateY(-2px)',
            boxShadow: '0 0 0 4px rgba(196,18,48,0.2), 0 14px 34px rgba(196,18,48,0.35)',
          },
          _active: { bg: 'crimson.600', transform: 'translateY(0)' },
        },
        goldOutline: {
          bg: 'transparent',
          color: 'gold.300',
          border: '1px solid',
          borderColor: 'gold.400',
          _hover: {
            bg: 'rgba(242,183,5,0.12)',
            textDecoration: 'none',
            boxShadow: '0 0 24px rgba(242,183,5,0.22)',
          },
        },
        crimsonOutline: {
          bg: 'transparent',
          color: 'crimson.500',
          border: '1px solid',
          borderColor: 'crimson.200',
          _hover: {
            bg: 'rgba(196,18,48,0.08)',
            textDecoration: 'none',
            borderColor: 'crimson.500',
          },
        },
      },
    },
  },
})
